module.exports = __webpack_public_path__ + "static/media/loading.f6076e2c.svg";